<template>
  <el-select v-model="year" v-on:change="doChange" filterable>
    <el-option v-for="yearData in yearList" :key="yearData" :label="yearData" :value="yearData"></el-option>
  </el-select>
</template>

<script>
export default {
  name: "Yean",
  props: ['started', 'max'],
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      yearList: [],
      year: new Date().getFullYear(),
    }
  },
  methods: {
    doChange(ev) {
      this.$emit('change', ev)
    },
  },
  mounted() {
    const vm = this;
    const max = +vm.max || 50;
    let started = +vm.started || +(new Date().getFullYear());
    for (let i = 0; i < max; i++) {
      vm.yearList.push(started);
      started--;

    }
  }
}

</script>